
export const splitDeviceAndVehicleIds = (selection) => {
  const deviceIds = [];
  const vehicleIds = [];

  const processItem = (item) => {
    if (!item) return;
    if (typeof item === "object") {
      if (item.gpsRefId != null && item.gpsRefId !== "") {
        deviceIds.push(item.gpsRefId);
      } else if (item.id != null && item.id !== "") {
        vehicleIds.push(item.id);
      }
    } else if (typeof item === "number" || typeof item === "string") {
      deviceIds.push(item);
    }
  };

  if (Array.isArray(selection)) {
    selection.forEach(processItem);
  } else if (selection) {
    processItem(selection);
  }

  return { deviceIds, vehicleIds };
};

